import React from 'react';
import { mapStateToProps, TopActivitiesAroundYouProps } from 'component/page/home/TopActivitiesAroundYou/TopActivitiesAroundYou.selectors';
import { Box, HorizontalScroll } from '@drone-js/core';
import { connect } from 'react-redux';
import { OperationKey } from 'store/api/api.types';
import { ActivitySingleCardPlaceHolder } from 'component/common/ActivityCard/PlaceHolder/ActivityCardPlaceHolder';
import RecommendedActivitiesCarousel from 'component/common/RecommendedActivitiesCarousel/RecommendedActivitiesCarousel';
import { SortCode } from 'gql/autogen/SortCode';
import { SortOrder } from 'gql/autogen/SortOrder';

const NUMBER_OF_ACTIVITIES = 12;

const TopActivitiesAroundYouPlaceholder: React.FC = () => {
    return (
        <HorizontalScroll pt="16" data-element-name="top-activities-around-you-carousel-placeholder">
            {[...Array<number>(NUMBER_OF_ACTIVITIES)].map((_, i) => (
                <Box key={i} me="12" width="270px">
                    <ActivitySingleCardPlaceHolder responsive={false} />
                </Box>
            ))}
        </HorizontalScroll>
    );
};
TopActivitiesAroundYouPlaceholder.displayName = 'TopActivitiesAroundYouPlaceholder';

const TopActivitiesAroundYouComponent: React.FC<TopActivitiesAroundYouProps> = (props) => {
    if (!props.cityId) {
        return null;
    }

    return (
        <Box display="flex" flexDirection="column" width="100%" mb={props.isPageContainerSpacing ? '32' : '48'} data-testid="top-activities-around-you-carousel-container">
            <RecommendedActivitiesCarousel
                cityId={props.cityId}
                title={props.config.cms[321405]}
                isPopularActivities={true}
                operationKey={OperationKey.HomePageTopActivitiesAroundYou}
                dataElementName="top-activities-around-you-carousel"
                dataElementValue="activities-top-activities-horizontal-scroll"
                numberOfActivities={NUMBER_OF_ACTIVITIES}
                defaultSort={{
                    code: SortCode.ActivitiesHomepageTopActivitiesCarousel,
                    order: SortOrder.Descending,
                }}
            />
        </Box>
    );
};

TopActivitiesAroundYouComponent.displayName = 'TopActivitiesAroundYou';

export default connect(mapStateToProps)(TopActivitiesAroundYouComponent);
export { TopActivitiesAroundYouPlaceholder };
